import { render, staticRenderFns } from "./SuperUserCompanyShow.vue?vue&type=template&id=0c31e0ff&scoped=true&"
import script from "./SuperUserCompanyShow.vue?vue&type=script&lang=js&"
export * from "./SuperUserCompanyShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c31e0ff",
  null
  
)

export default component.exports